import { wizardTrackingIds } from 'client/tracking/maps/incentives-wizard';

export const TRACKING_BY_GRANTOR = {
  Treehouse: {
    trackingId: wizardTrackingIds.treehouseClickout,
    trackingValue: '',
    creativeId: 'treehouse-promotion-wizard',
  },
};
